import HandbookFormModal from "features/handbook/ui/form/HandbookFormModal";
import { Handbook } from "features/handbook/model/handbook";
import { HandbookFieldFlags } from "features/handbook/lib/handbookFieldFlags";

type Props = {
  open: boolean;
  loading?: boolean;
  initial: Handbook | null;
  onCancel: () => void;
  onSubmit: (payload: Partial<Handbook>) => void;
  flags: HandbookFieldFlags;
  /** Обязательные поля из swagger-схемы справочника. */
  requiredFields: readonly string[];
  /** У этих справочников форма ведёт себя особым образом. */
  isTerritorialUnit: boolean;
  isAgroCredit: boolean;
};

/** Раскладывает выведенные из данных флаги полей в пропсы формы справочника. */
export const HandbookEditModal = ({
  open,
  loading,
  initial,
  onCancel,
  onSubmit,
  flags,
  requiredFields,
  isTerritorialUnit,
  isAgroCredit,
}: Props) => (
  <HandbookFormModal
    open={open}
    loading={loading}
    initial={initial}
    onCancel={onCancel}
    onSubmit={onSubmit}
    showCategory={flags.hasCategory}
    showType={flags.hasType}
    showAlias={flags.hasAlias}
    showBik={flags.hasBik}
    showBank={flags.hasBank}
    showAddress={flags.hasAddress}
    showDivision={flags.hasDivision}
    showOrder={flags.hasOrder}
    showThresholdPerM2={flags.hasThresholdPerM2}
    showDataSourceStatus={flags.hasDataSourceStatus}
    showUnitMeasurement={flags.hasUnitMeasurement}
    showRegion={flags.hasRegion}
    showCrop={flags.hasCrop}
    showDescriptionRu={flags.hasDescriptionRu}
    showDescriptionKy={flags.hasDescriptionKy}
    categoryFieldKey={flags.categoryFieldKey}
    typeFieldKey={flags.typeFieldKey}
    unitMeasurementFieldKey={flags.unitMeasurementFieldKey}
    cropFieldKey={flags.cropFieldKey}
    bankFieldKey={flags.bankFieldKey}
    requiredFields={requiredFields}
    isTerritorialUnit={isTerritorialUnit}
    isAgroCredit={isAgroCredit}
  />
);
